import { generateTestId } from "@client-shared";

const TEST_ID_PREFIX = "ServiceTile";

/** Platform identifiers for service tiles */
export const SERVICE_TILE_PLATFORMS = {
  shopify: "shopify",
  woocommerce: "woocommerce",
} as const;

export type ServiceTilePlatform = keyof typeof SERVICE_TILE_PLATFORMS;

/**
 * Static test IDs for service tiles.
 * Use these constants for consistent test ID references.
 */
export const SERVICE_TILE_TEST_IDS = {
  shopify: generateTestId(TEST_ID_PREFIX, "tile", SERVICE_TILE_PLATFORMS.shopify),
  woocommerce: generateTestId(TEST_ID_PREFIX, "tile", SERVICE_TILE_PLATFORMS.woocommerce),
} as const;

/**
 * Get the test ID for a service tile by platform.
 * @param platform - The platform identifier
 */
export const getServiceTileTestId = (platform: ServiceTilePlatform): string => SERVICE_TILE_TEST_IDS[platform];
